/**
 * Config Service
 * Wraps the passenger app-config endpoint:
 *   GET /v1/passengers/config/app
 * The response powers BOOKING_CONSTRAINTS (constants/booking.js).
 */

import { customersApiClient } from './apiClient';

const API_ENDPOINTS = {
  APP_CONFIG: '/config/app',
  POLICIES: '/config/policies',
};

export const configService = {
  async getAppConfig() {
    const result = await customersApiClient.get(API_ENDPOINTS.APP_CONFIG);

    if (result.success) {
      return { success: true, data: result.data || null, error: null };
    }

    return {
      success: false,
      data: null,
      error: result.error || 'Failed to fetch app config',
    };
  },

  /**
   * The POLICY CATALOG — every direction × distance band, not one trip's resolved
   * policy. `/trips/calculate-policies` answers "what applies to THIS booking";
   * this answers "what are the rules", which is what /help has to show.
   *
   * Shape: {cancellation: {directions[]}, modification: {directions[]}, waiting,
   * payments, fees, …}; each direction carries distance_bands[] and each band its
   * tiers[].
   */
  async getPolicyCatalog() {
    const result = await customersApiClient.get(API_ENDPOINTS.POLICIES);

    if (result.success) {
      return { success: true, data: result.data || null, error: null };
    }

    return {
      success: false,
      data: null,
      error: result.error || 'Failed to fetch policies',
    };
  },
};

export default configService;
